export default __webpack_public_path__ + "static/media/19.74dbd7b1.jpg";